/**
 * Utilitários compartilhados do Dashboard Professor
 */

/** Converte "HH:MM" em minutos desde meia-noite */
export function toMin(hhmm: string): number {
  const [h, m] = hhmm.split(':').map(Number);
  return (h || 0) * 60 + (m || 0);
}

/** Converte segundos em formato legível para countdown.
 * - Abaixo de 1h:     "MM:SS"  (ex: 12:45)
 * - 1h a 24h:         "Xh YYmin" (ex: 2h 30min)
 * - Acima de 24h:     "Xd Yh"   (ex: 1d 14h)
 */
export function fmtTimer(s: number): string {
  if (s <= 0) return '00:00';
  const dias = Math.floor(s / 86400);
  const horas = Math.floor((s % 86400) / 3600);
  const minutos = Math.floor((s % 3600) / 60);
  const segundos = s % 60;

  if (dias > 0) {
    return horas > 0 ? `${dias}d ${horas}h` : `${dias}d`;
  }
  if (horas > 0) {
    return minutos > 0 ? `${horas}h ${minutos}min` : `${horas}h`;
  }
  return `${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
}

/** Nome limpo (remove "Prof." etc.) */
export function cleanName(nome?: string): string {
  if (!nome) return 'Professor';
  return nome.replace(/^(Prof\.|Profa\.|Prof\u00aa|Prof\u00ba)\s+/i, '');
}

/** Retorna duração em formato legível: "45min", "1h", "1h30" */
export function fmtDuracao(ini: string, fim: string): string {
  const min = toMin(fim) - toMin(ini);
  if (min <= 0) return '';
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return m === 0 ? `${h}h` : `${h}h ${String(m).padStart(2, '0')}min`;
}

/** Retorna duração total de um array de aulas (em minutos) */
export function totalMinGrupo(aulas: any[]): number {
  return aulas.reduce((acc: number, h: any) => {
    if (!h.horaInicio || !h.horaFim) return acc;
    return acc + Math.max(0, toMin(h.horaFim) - toMin(h.horaInicio));
  }, 0);
}

/** Janela de tolerância: 60 minutos após o fim da aula ainda pode fazer chamada */
export const TOLERANCIA_CHAMADA_MIN = 60;

// useIsMobile é mantido no ProfessorDashboard.tsx pois requer useState/useEffect do React
